import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
};
const defaultProps = {};

const ButtonWrapper = styled.div`
  font-size: 16px;
  color: #ffffff;
  border: 0px;
  cursor: pointer;
  display: inline-block;
  padding: 15px 25px;
  ${props => `
    background-color: ${props.disabled ? "#E9ECDA" : "#447170"}
  `};
`;

function Button({ handleClick, text, disabled, loading }) {
  return (
    <ButtonWrapper onClick={handleClick} disabled={disabled}>
      {!loading ? text : "Generating..."}
    </ButtonWrapper>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js